import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.css']
})
export class BlankComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.navigate([{
      outlets: {
        sidebar: ['menus'],
        primary: ['monitor-processos']
      }
    }], { skipLocationChange: true });
  }

}
